import React from 'react';
import { Skeleton } from '@mui/material';
import { images } from '../../../../constants/images';
import { PublicationMobileActionsProps } from '../../interfaces';
import styles from '../../publicationDetailMobile.module.scss';



const PublicationMobileActions: React.FC<PublicationMobileActionsProps> = ({
    publication,
    loading,
    isBonus
}) => {
    if (loading || (!publication?.certified && !isBonus)) {
        return null;
    }

    return (
        <div className={styles.certifiedFinancing}>
            {publication?.certified && (
                <div className={`${styles.item} ${styles.certified}`}>
                    <p>Vehículo verificado</p>
                    <img src={images.check_blue} alt="vehículo verificado" title="vehículo verificado"/>
                </div>
            )}
            {isBonus && (
                <div className={`${styles.item} ${styles.financingBonus}`}>
                    <img src={images.financingBonus} alt="bono con financiamiento" title="bono con financiamiento" />
                    <p>Bono con financiamiento</p>
                </div>
            )}
        </div>
    );
};

export default PublicationMobileActions;
